import {
    ReactNode,
    FC,
    createContext,
    useState,
    useMemo,
    useEffect,
} from 'react';
import * as types from '@models/types';
import { DropdownItemType } from '@components/Dropdown';

type CountriesContextType = {
    regionList?: DropdownItemType[];
    setRegionList?: React.Dispatch<React.SetStateAction<DropdownItemType[]>>;
    regionDetails?: types.RegionType[];
    setRegionDetails?: React.Dispatch<React.SetStateAction<types.RegionType[]>>;
    countryList?: types.CountryType[];
    setCountryList?: React.Dispatch<React.SetStateAction<types.CountryType[]>>;
    countryDetails?: any;
    setCountryDetails?: React.Dispatch<React.SetStateAction<any>>;
};

const CountriesContext = createContext<CountriesContextType>({});

type CountriesProps = {
    children: ReactNode;
};

const Countries: FC<CountriesProps> = ({ children }) => {
    const [regionList, setRegionList] = useState<DropdownItemType[]>([]);
    const [regionDetails, setRegionDetails] = useState<types.RegionType[]>([]);
    const [countryList, setCountryList] = useState<types.CountryType[]>([]);
    const [countryDetails, setCountryDetails] = useState<any>([]);

    const countriesProviderValue = useMemo(
        () => ({ regionList, setRegionList, regionDetails, setRegionDetails, countryList, setCountryList, countryDetails, setCountryDetails }),
        [regionList, setRegionList, regionDetails, setRegionDetails, countryList, setCountryList, countryDetails, setCountryDetails],
    );

    useEffect(() => { }, []);

    return (
        <CountriesContext.Provider value={countriesProviderValue}>
            {children}
        </CountriesContext.Provider>
    );
};

export { Countries, CountriesContext };
